import React from "react";
import { CheckCircle2, XCircle, Clock, ShieldCheck, AlertTriangle, Wallet, Cloud } from "lucide-react";
import { LANES, PHASES } from "./onboardShared";

export function StepBadge({ state }) {
  if (!state) return <Clock size={13} className="text-zinc-600" />;
  if (state.ok) return <CheckCircle2 size={13} className="text-emerald-400" />;
  if (state.skipped) return <Clock size={13} className="text-zinc-600" />;
  return <XCircle size={13} className="text-rose-400" />;
}

export function OnboardHeader({ phase }) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="font-display text-3xl font-black tracking-tight">Onboard Domains</h1>
        <div className="text-zinc-500 text-sm mt-1">Buy new (Namecheap or Cloudflare Registrar) or bring your own → auto-build a distinct site → Cloudflare + email, in one pass.</div>
      </div>
      <div className="flex items-center gap-1.5">
        {PHASES.map((p, i) => (
          <div key={p} className={`flex items-center gap-1.5 text-xs mono uppercase tracking-wider px-2.5 py-1 rounded-sm ${phase === p ? "bg-amber-500/15 text-amber-300 border border-amber-500/30" : "text-zinc-600"}`}>
            <span>{i + 1}</span><span>{p}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function LaneTabs({ lane, onSwitch }) {
  return (
    <div className="mt-5 flex items-center gap-2 border-b border-zinc-800">
      {LANES.map((l) => (
        <button key={l.key} data-testid={`domains-lane-${l.key}`} onClick={() => onSwitch(l.key)}
          className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition ${lane === l.key ? "border-amber-500 text-white" : "border-transparent text-zinc-500 hover:text-zinc-200"}`}>
          <l.icon size={15} /> {l.label}
        </button>
      ))}
    </div>
  );
}

const badge = (tone) => `inline-flex items-center gap-1.5 mono uppercase tracking-wider px-2 py-0.5 rounded-sm border ${tone}`;
const GREEN = "bg-emerald-500/10 text-emerald-400 border-emerald-500/30";
const AMBER = "bg-amber-500/10 text-amber-400 border-amber-500/30";
const ROSE = "bg-rose-500/10 text-rose-400 border-rose-500/30";

function cfRegState(cfReg) {
  if (cfReg?.ok) return { tone: GREEN, label: "LIVE" };
  if (cfReg?.configured) return { tone: ROSE, label: "NO ACCESS" };
  return { tone: AMBER, label: "OFF" };
}

export function PreflightBar({ preflight, cfReg, balance }) {
  const cf = cfRegState(cfReg);
  return (
    <div data-testid="domains-preflight" className="mt-4 flex flex-wrap items-center gap-3 border border-zinc-800 bg-zinc-900/40 rounded-sm px-4 py-3 text-xs">
      {!preflight && <span className="text-zinc-500">Loading preflight…</span>}
      {preflight && (
        <>
          <span className={badge(preflight.namecheap_live ? GREEN : AMBER)}>
            {preflight.namecheap_live ? <ShieldCheck size={12} /> : <AlertTriangle size={12} />} Namecheap {preflight.namecheap_live ? `LIVE (${preflight.namecheap_env})` : "MOCK"}
          </span>
          <span className={badge(preflight.cloudflare_configured ? GREEN : ROSE)}>Cloudflare {preflight.cloudflare_configured ? "OK" : "OFF"}</span>
          <span data-testid="domains-cfreg-badge" title={cfReg?.error || (cfReg?.ok ? `token: ${cfReg.token_source}` : "")} className={badge(cf.tone)}>
            <Cloud size={12} /> CF Registrar {cf.label}
          </span>
          {balance != null && (
            <span data-testid="domains-balance" className="inline-flex items-center gap-1.5 text-zinc-300 mono ml-auto">
              <Wallet size={13} className="text-amber-400" /> NC balance: <b className="text-white">${balance.toFixed(2)}</b> {preflight.balance?.currency}
            </span>
          )}
        </>
      )}
    </div>
  );
}
